import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Typography } from "antd";
import moment from "moment";

import Table from "../../../shared/components/ui/Table";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { DataWalletBonus } from "../../../redux/@types/walletBonus";
import { walletBonusService } from "../../../shared/services";
import { useTableWalletBonus, useWalletBonus } from "../hooks";
import { decimal } from "../../../shared/utils/Helper";

const { Title } = Typography;

export const TableWalletBonus = () => {
  const { changeWalletBonusForUpdate, showDeleteConfirm } =
    useTableWalletBonus();
  const { setTableProps, updateStatus, isLoading  } = useWalletBonus();
  const columns: TableColumns<DataWalletBonus> = [
    {
      title: "ID",
      width: 3,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Nombre",
      width: 7,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Cantidad",
      width: 5,
      dataIndex: "quantity",
      key: "quantity",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Title style={{ fontSize: "0.74rem", fontWeight: "500" }} level={5}>
              $ {decimal(item.quantity)}
            </Title>
          </Col>
        );
      },
    },
    {
      title: "Estado",
      width: 5,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
            disabled={isLoading}
              onClick={()=>{
                if(item.status === "active"){
                  updateStatus("inactive", item.id)
                }else if( item.status === "inactive"){
                  updateStatus("active", item.id)
                }
              }}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Días para la caducidad ",
      width: 5,
      dataIndex: "expire_days",
      key: "expire_days",
    },
    {
      title: "Fecha de creación",
      width: 7,
      dataIndex: "createdAt",
      key: "createdAt",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Title style={{ fontSize: "0.74rem", fontWeight: "500" }} level={5}>
              {moment(item.createdAt).add("h", 5).format("DD/MM/YYYY")}
            </Title>
          </Col>
        );
      },
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 3,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              shape="circle"
              onClick={() => changeWalletBonusForUpdate(item)}
              icon={<EditOutlined />}
              size="large"
            />
            <Button
              type="primary"
              danger
              onClick={() => showDeleteConfirm(item.id, `${item.name}`)}
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <Table<DataWalletBonus>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={walletBonusService}
      onLoad={setTableProps}
    />
  );
};
